export const BRAND = {
  name: "OpenDegree",
  tagline: "Opening the Door to Higher Education.",
  logo: "https://customer-assets-0z36b82j.emergentagent.net/job_opendegree-v1/artifacts/3m62vmbd_ChatGPT%20Image%20Sep%204%2C%202026%2C%2011_50_54%20AM.png",
  emails: {
    partnerships: "partnerships@opendegree.co.uk",
    general: "hello@opendegree.co.uk",
  },
  notifyMailto:
    "mailto:hello@opendegree.co.uk?subject=Notify%20me%20when%20OpenDegree%20launches&body=Hi%20OpenDegree%20team%2C%20please%20let%20me%20know%20when%20you%20launch.",
};
